module.exports = __webpack_public_path__ + "img/TXOC logo.8825f4f6.svg";